import Env from '../config/envConfig'

import {
  AutorisationROApi as AutorisationROApiClass,
  Configuration,
  CaptchaRestServiceApi as CaptchaRestServiceApiClass,
} from '@professocialApi/professocial-core-frontend-api'
import customFetchApi from './customFetchApi'

const BASE_PATH_API = Env.restBase

export const AutorisationROApi = new AutorisationROApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const CaptchaRestServiceApi = new CaptchaRestServiceApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))
